import type { ComponentType } from "react";

import {
  ArrowDownIcon,
  ArrowUpIcon,
  HistoryToggleOffIcon,
  RadioButtonUncheckedIcon,
  SvgIconProps,
} from "veneer/SvgIcon";
import { Colors } from "veneer/Theme";

type DeviceStatus = {
  chartColor?: string;
  code?: number;
  color: string;
  icon?: ComponentType<SvgIconProps>;
  iconClass: string;
  id: string;
  label: string;
  textClass: string;
};

const DEVICE_HIBERNATING: DeviceStatus = {
  chartColor: Colors.yellow700,
  code: 1,
  color: "teal",
  icon: HistoryToggleOffIcon,
  iconClass: "fa-moon-o",
  id: "hibernating",
  label: "Hibernating",
  textClass: "text-muted",
};

const DEVICE_OFFLINE: DeviceStatus = {
  chartColor: Colors.red700,
  code: 2,
  color: "red",
  icon: ArrowDownIcon,
  iconClass: "fa-arrow-down",
  id: "offline",
  label: "Offline",
  textClass: "text-danger",
};

const DEVICE_ONLINE: DeviceStatus = {
  chartColor: Colors.green700,
  code: 0,
  color: "green",
  icon: ArrowUpIcon,
  iconClass: "fa-arrow-up",
  id: "online",
  label: "Online",
  textClass: "text-success",
};

const DEVICE_SHELL: DeviceStatus = {
  chartColor: Colors.gray700,
  code: 0,
  color: "grey",
  icon: RadioButtonUncheckedIcon,
  iconClass: "fa-circle-o",
  id: "shell",
  label: "Registered, Never Connected",
  textClass: "text-muted",
};

const DEVICE_ALL = {
  code: -1,
  label: "All",
  id: "total",
} as const;

// As we introduce device status pipeline to synchronize state, this
// limit should be 2x the ws polling period to have margins for latency.
const DEVICE_STATUS_TIMEOUT_MS = 120000;

export {
  DEVICE_ALL,
  DEVICE_HIBERNATING,
  DEVICE_OFFLINE,
  DEVICE_ONLINE,
  DEVICE_SHELL,
  DEVICE_STATUS_TIMEOUT_MS,
};
